import types from './types';

const initialState = {
  list: [],
};

const giftCards = (state = initialState, action) => {
  switch (action.type) {
    case types.GIFTCARDS__GET_GIFTCARDS:
      return {
        ...state,
        ...action.payload,
      };
    case types.GIFTCARDS__MANAGE_GIFTCARDS:
      return {
        ...state,
        ...action.payload,
      };
    default: {
      return state;
    }
  }
};

export default giftCards;
